import { Injectable, inject, signal } from '@angular/core';
import { PromotionsApiService } from '../api/promotions-api.service';
import { dtoAPrecioBajo, precioBajoADto } from '../api/promotions.mapper';
import {
  OfertaPrecioBajo,
  PrecioBajoEdicionRapida,
  PrecioBajoFormValue,
  SucursalOferta,
} from '../models/promociones.model';
import { SucursalesService } from './sucursales.service';

@Injectable({ providedIn: 'root' })
export class PreciosBajosService {
  private api = inject(PromotionsApiService);
  private sucursalesService = inject(SucursalesService);

  readonly ofertas = signal<OfertaPrecioBajo[]>([]);

  constructor() {
    this.cargar();
  }

  cargar(): void {
    this.api.listarPreciosBajos().subscribe({
      next: (lista) => this.ofertas.set(lista.map(dtoAPrecioBajo)),
      error: (error) =>
        console.error('[Promociones] No se pudieron cargar las ofertas de precio bajo', error),
    });
  }

  sucursalesPorDefecto(): SucursalOferta[] {
    return this.sucursalesService.paraOferta();
  }

  obtenerPorId(id: string): OfertaPrecioBajo | undefined {
    return this.ofertas().find((o) => o.id === id);
  }

  crear(form: PrecioBajoFormValue): void {
    this.api.crearPreciosBajos(precioBajoADto(form)).subscribe({
      next: () => this.cargar(),
      error: (error) => console.error('[Promociones] No se pudo crear la oferta', error),
    });
  }

  actualizar(id: string, cambios: PrecioBajoEdicionRapida): void {
    this.api
      .editarPrecioBajo(id, {
        offerPrice: cambios.precio,
        minQuantity: cambios.cantidadMinima,
        maxQuantity: cambios.cantidadMaxima,
        stock: cambios.stock,
      })
      .subscribe({
        next: () => this.cargar(),
        error: (error) => console.error('[Promociones] No se pudo actualizar la oferta', error),
      });
  }

  eliminar(id: string): void {
    this.api.eliminarPrecioBajo(id).subscribe({
      next: () => this.cargar(),
      error: (error) => console.error('[Promociones] No se pudo eliminar la oferta', error),
    });
  }
}
